/*
 * @Author: @dev2_guomin guomin0702@163.com
 * @Date: 2024-07-03 19:14:14
 * @LastEditors: @dev2_guomin guomin0702@163.com
 * @LastEditTime: 2024-07-04 19:18:04
 * @FilePath: \jtport-wisdom-station-front\src\api\handover\integratedQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/router/axios";

export const getList = (params) => {
  return request({
    url: "/check/train/trainQuery/getTrainListData",
    method: "get",
    params,
  });
};

export const getDetail = (params) => {
  return request({
    url: "/check/train/trainQuery/getTrainDetailList",
    method: "get",
    params,
  });
};

export const exportExcel = (params) => {
  return request({
    url: "/check/train/trainQuery/export",
    method: "get",
    params,
    responseType: "blob",
  });
};
